import React, { useContext, useState, useRef, useEffect } from 'react';
import componentUtil from 'utils/component';
import { LoaderContext } from 'components/theme/loader';
import FeatureFlagService from 'services/feature-flag';

export default function withFetchInitialSplitFlagsHOC(Component) {
  const WithFetchInitialSplitFlags = (props) => {
    const loaderRef = useRef();
    const [flagsFetchDate, setFlagsFetched] = useState(false);
    const { showLoader, hideLoader } = useContext(LoaderContext);

    useEffect(() => {
      loaderRef.current = showLoader({ showLoader: true });
      FeatureFlagService.onSdkReady(() => {
        hideLoader(loaderRef.current);
        setFlagsFetched(true);
      });
    }, []);

    return <>{flagsFetchDate ? <Component {...props} /> : null}</>;
  };
  WithFetchInitialSplitFlags.displayName = componentUtil.getDisplayName(
    Component,
    'WithFetchInitialSplitFlags'
  );
  return WithFetchInitialSplitFlags;
}
